// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import LecturePrototypeModuleListPagingResultModel from '../../model/lecture-prototype-module-list-paging-result-model';
import LecturePrototypeModuleListPagingResultDTO from '../dto/lecture-prototype-module-list-paging-result-dto';
import dtoSchema from '../schemas/lecture-prototype-module-list-paging-result-schema';
import LecturePrototypeModuleListModel from '../../model/lecture-prototype-module-list-model';
import ResourceLinkModel from '../../model/resource-link-model';
import PaginationDataModel from '../../model/pagination-data-model';

export default abstract class LecturePrototypeModuleListPagingResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<LecturePrototypeModuleListPagingResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => LecturePrototypeModuleListModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.paginationData = data.paginationData ? PaginationDataModel.toModel(data.paginationData) : undefined;
    }
  }
  /**
  */
  items?: LecturePrototypeModuleListModel[];
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  paginationData?: PaginationDataModel;

  static toModel(dto: DeepPartial<LecturePrototypeModuleListPagingResultDTO>): LecturePrototypeModuleListPagingResultModel;
  static toModel(dto: DeepPartial<LecturePrototypeModuleListPagingResultDTO> | undefined | null): LecturePrototypeModuleListPagingResultModel | undefined;
  static toModel(dto: DeepPartial<LecturePrototypeModuleListPagingResultDTO> | undefined | null): LecturePrototypeModuleListPagingResultModel | undefined {
    return dto ? new LecturePrototypeModuleListPagingResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<LecturePrototypeModuleListPagingResultModel> | LecturePrototypeModuleListPagingResultModel): LecturePrototypeModuleListPagingResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
      paginationData: unwrapped.paginationData,
    } as LecturePrototypeModuleListPagingResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for LecturePrototypeModuleListPagingResultModel, can not map to LecturePrototypeModuleListPagingResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
